import React, { useEffect, useState } from "react";
import * as R from "ramda";

export const Path = ({ relocatedUser, declaration, userLetters }) => {
	const [step, setStep] = useState(0);
	useEffect(() => {
		if (R.isNil(declaration) || declaration.onBoardingStep < 5) {
			setStep(1);
		} else {
			if (R.isNil(declaration.onBoardingStep) || declaration.onBoardingStep < 6) {
				setStep(2);
			} else if (declaration.onBoardingStep === 5) {
				if (userLetters.every((l) => l.letterProgressStage !== "Created")) {
					setStep(3);
				} else {
					setStep(2);
				}
			}
		}
	}, [declaration, relocatedUser, userLetters]);

	if (R.isNil(relocatedUser)) {
		return "";
	}
	return (
		<div className="stepper order-md-first">
			<ul className="nav stepper-nav gap-xs">
				<li className={"stepper-item stepper-center" + (step === 1 ? " active" : step > 1 ? " completed" : "")}>
					<span className="stepper-icon align-self-center">1</span>
					<span className="stepper-title mx-auto px-0">COMPLETER</span>
				</li>
				<li className={"stepper-item stepper-center" + (step === 2 ? " active" : step > 2 ? " completed" : "")}>
					<span className="stepper-icon align-self-center">2</span>
					<span className="stepper-title mx-auto px-0">VALIDER</span>
				</li>
				<li className={"stepper-item stepper-center" + (step === 3 ? " active" : step > 3 ? " completed" : "")}>
					<span className="stepper-icon align-self-center">3</span>
					<span className="stepper-title mx-auto px-0">COURRIERS / SUIVI</span>
				</li>
			</ul>
		</div>
	);
};
